export default "__VITE_ASSET__jAE56KOv__"